/**
 * The paths the public published pages answer on.
 *
 * A published link is `/p/<owner>/<slug>` — three segments, the same shape as
 * `/:startupSlug/:scopeId/:conversationId`. React Router ranks by specificity, and a splat
 * scores badly: `/p/*` comes out at 12 against the conversation route's 14, so every published
 * prototype resolved as a startup and rendered "Startup not found". The explicit two-parameter
 * patterns score 21 and win; the splats stay for any other shape (a one-segment legacy slug, or
 * a slug that itself contains a slash).
 *
 * Kept here, next to the page that consumes them, so the rule is one exported list a test can
 * check rather than a line of JSX whose ordering looks harmless.
 */

export const PROTOTYPE_ROUTE_PATHS = ['/p/:owner/:slug', '/p/*'] as const;

export const ARTIFACT_ROUTE_PATHS = ['/a/:owner/:slug', '/a/*'] as const;

/** The startup route a published link used to lose to; exported for the regression test. */
export const SCOPE_CONVERSATION_ROUTE_PATH = '/:startupSlug/:scopeId/:conversationId';
